import { put } from 'redux-saga/effects';
import { ShiftSchedulerAction } from '../actions';
import { ApiCaller, Utils } from '../../config';

export default class ShiftSchedulerMiddleware {
    static *GetPotentialTakers(params) {
        const { payload, cb } = params;
        try {
            let res = yield ApiCaller.Get('/potential-takers', payload);
            if (res.status == 200) {
                yield put(
                    ShiftSchedulerAction.GetPotentialTakersSuccess(
                        res?.data?.data,
                    ),
                );
                cb && cb();
            } else {
                // any non-200 (204/304/…) must still release the loader
                yield put(ShiftSchedulerAction.GetPotentialTakersFailure());
            }
        } catch (error) {
            yield put(ShiftSchedulerAction.GetPotentialTakersFailure());
            Utils.showMessage('error', error?.response?.data?.message);
        }
    }

    // static *GetShifts(params) {
    //     const { payload, cb } = params;
    //     try {
    //         let res = yield ApiCaller.Get(
    //             `/shifts?perPage=${payload?.limit}&page=${payload?.page}&user_id=${payload?.filterDrawer?.user ? payload?.filterDrawer?.user : ''}&eligibility_id=${payload?.filterDrawer?.eligiblity ? payload?.filterDrawer?.eligiblity : ''}&schedule_id=${payload?.filterDrawer?.schedule ? payload?.filterDrawer?.schedule : ''}&${payload?.tabKey ? `open_shift=${payload?.tabKey}` : ''}&today=${payload?.today}`,
    //         );

    //         if (res.status == 200) {
    //             yield put(ShiftSchedulerAction.GetShiftsSuccess(res?.data));
    //         }
    //     } catch (err) {
    //         yield put(ShiftSchedulerAction.GetShiftsFailure());
    //         Utils.showMessage('error', err?.response?.data?.message);
    //     }
    // }
    static *GetShifts(params) {
        const { payload, cb } = params;

        // Conditionally build the query string
        let queryString = `/shifts?perPage=${payload?.limit}&page=${payload?.page}`;

        if (payload?.filterDrawer?.user)
            queryString += `&user_id=${payload.filterDrawer.user}`;
        if (payload?.filterDrawer?.eligiblity)
            queryString += `&eligibility_id=${payload.filterDrawer.eligiblity}`;
        if (payload?.filterDrawer?.schedule)
            queryString += `&schedule_id=${payload.filterDrawer.schedule}`;
        if (payload?.tabKey) queryString += `&open_shift=${payload.tabKey}`;

        // Only add `today` if it's defined
        if (payload?.today !== undefined) {
            queryString += `&today=${payload.today}`;
        }

        try {
            let res = yield ApiCaller.Get(queryString);

            if (res.status === 200) {
                yield put(ShiftSchedulerAction.GetShiftsSuccess(res?.data));
            } else {
                // any non-200 (204/304/…) must still release the loader
                yield put(ShiftSchedulerAction.GetShiftsFailure());
            }
        } catch (err) {
            yield put(ShiftSchedulerAction.GetShiftsFailure(Utils.isSubscriptionError(err)));
            Utils.showMessage('error', err?.response?.data?.message);
        }
    }

    static *GetMyShifts(params) {
        const { payload, cb } = params;

        // Retrieve the user data from localStorage
        const user = localStorage.getItem('user');
        let userId = null;

        if (user) {
            try {
                const parsedUser = JSON.parse(user);
                userId = parsedUser?.id;
                if (!userId) {
                    console.error('User ID not found in the parsed data.');
                    yield put(ShiftSchedulerAction.GetMyShiftFailure());
                    return;
                }
            } catch (error) {
                console.error(
                    'Failed to parse user data from localStorage:',
                    error,
                );
                yield put(ShiftSchedulerAction.GetMyShiftFailure());
                return;
            }
        } else {
            console.error('User data not found in localStorage.');
            yield put(ShiftSchedulerAction.GetMyShiftFailure());
            return;
        }

        try {
            const url = `/shifts?perPage=${payload?.limit}&page=${payload?.page}&user_id=${userId}&eligibility_id=${payload?.filterDrawer?.eligiblity ? payload?.filterDrawer?.eligiblity : ''}&schedule_id=${payload?.filterDrawer?.schedule ? payload?.filterDrawer?.schedule : ''}&open_shift=${payload?.tabKey}`;

            let res = yield ApiCaller.Get(url);
            if (res.status === 200) {
                yield put(ShiftSchedulerAction.GetMyShiftSuccess(res?.data));
                console.log('shiftttt', res);
                if (cb) cb(null, res?.data);
            } else {
                // any non-200 (204/304/…) must still release the loader
                yield put(ShiftSchedulerAction.GetMyShiftFailure());
                if (cb) cb(null, res?.data);
            }
        } catch (err) {
            yield put(ShiftSchedulerAction.GetMyShiftFailure(Utils.isSubscriptionError(err)));
            if (cb) cb(err);
            Utils.showMessage('error', err?.response?.data?.message);
        }
    }
}
